import {PRIORITY_COUNTRIES_CODES} from './constants';
import type {Country} from './constants';

export const sortCountries = (countries: Country[]) => {
    return countries.sort((a, b) => a.translations.en.localeCompare(b.translations.en)).sort((a: Country, b: Country) => {
        if (PRIORITY_COUNTRIES_CODES.includes(b.countryCode) && PRIORITY_COUNTRIES_CODES.includes(a.countryCode)) {
            return PRIORITY_COUNTRIES_CODES.indexOf(a.countryCode) - PRIORITY_COUNTRIES_CODES.indexOf(b.countryCode);
        }

        if (PRIORITY_COUNTRIES_CODES.includes(a.countryCode)) {
            return -1;
        }

        if (!PRIORITY_COUNTRIES_CODES.includes(b.countryCode)) {
            return 0;
        }

        return 1;
    });
};

export const filterCountriesBySearch = (countries: Country[], search: string) => {
    if (!search) {
        return countries;
    }

    return countries.filter(
        (country) =>
            country.countryCallingCode.includes(search.replace('+', '')) ||
            country.translations.ru.toLowerCase().includes(search.toLowerCase()) ||
            country.translations.en.toLowerCase().includes(search.toLowerCase()),
    );
};
